import { formValidationConstants } from '../components/utils/constants/form-validation-constants';

export function validatePrivacyPolicy(privacyPolicy) {
    return validateBooleanValue(privacyPolicy, formValidationConstants.privacyPolicyErrorMessage);
}

export function validateOneClubTermsAndServicesPolicy(privacyPolicy) {
    return validateBooleanValue(privacyPolicy, formValidationConstants.oneClubTermsAndServicesErrorMessage);
}

function validateBooleanValue(value, errorMessage) {
    if (!value || value === false) {
        return {
            isValid: false, errorMessage
        };
    }

    return { isValid: true };
}
